<template>
  <div class="group-page">
    <div class="group-wrapper" v-if="!isMobile">
      <h1 class="group-wrapper__logo" />
      <div class="group-wrapper__content" v-if="!isEmpty">
        <div class="group-wrapper__avatar">
          <img :src="group.group_avatar" alt="群组头像">
        </div>
        <div class="group-wrapper__title">
          {{ group.group_name }}
        </div>
        <p class="group-wrapper__info">
          <span>群号：{{ group.group_id }}</span>
          <!-- <span>群成员：{{ group.group_member_count }}/{{
            group.group_max_size
          }}</span> -->
        </p>
        <div class="group-wrapper__code">
          <img :src="qrLink" alt="群组邀请码">
        </div>
        <p class="group-wrapper__text">
          打开迅雷APP，扫码加入群聊
        </p>
      </div>
      <div class="group-wrapper__content" v-else>
        <div class="group-wrapper__empty" />
        <p class="group-wrapper__text">
          群组不存在
        </p>
      </div>
    </div>
    <div class="group-mobile" v-else>
      <div class="group-mobile__add" v-if="!showAppTip && !isEmpty">
        <div class="group-mobile__avatar">
          <img :src="group.group_avatar" alt="群组头像">
        </div>
        <div class="group-mobile__name">
          {{
            group.group_name ||
              ''
          }}
        </div>
        <p class="group-mobile__info">
          <span>群号：{{ group.group_id }}</span>
          <!-- <span>群成员：{{ group.group_member_count }}/{{
            group.group_max_size
          }}</span> -->
        </p>
        <div class="group-mobile__add-button" @click="callApp()">加入群聊</div>
        <p class="group-mobile__tips" v-if="!isSupport">无法加入，请使用新版迅雷</p>
        <div class="group-mobile__cover" v-show="isShowTip">
          <span class="group-mobile__guide" />
        </div>
      </div>
      <div class="group-mobile__download" v-else-if="showAppTip && !isEmpty">
        <div class="group-mobile__logo" />
        <h1 class="group-mobile__title">
          请使用新版迅雷APP
        </h1>
        <p class="group-mobile__text">
          更安全 / 更高效 / 更智能
        </p>
        <div class="group-mobile__button" @click="callApp('download_now')">
          立即下载
        </div>
        <p class="group-mobile__link" @click="callApp('installed_open')">
          已安装APP？点击打开
        </p>
        <div class="group-mobile__cover" v-show="isShowTip">
          <span class="group-mobile__guide" />
        </div>
      </div>
      <div class="group-mobile__empty" v-else>
        <div class="group-mobile__empty-image" />
        <p>{{ emptyText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from 'js-base64'
import { postGroupQuery } from '@/api'
import createQrCode from '@/utils/qrImg'

export default {
  data () {
    return {
      isEmpty: false,
      isShowTip: false,
      qrLink: '',
      group: {
        group_id: 0,
        group_name: '',
        group_avatar: '',
        status: 0,
        creator_uid: 0,
        group_max_size: 0,
        group_member_count: 0,
        class: 3,
        extra: '',
        created_at: 1654495795,
        join_group_method: 0
      },
      showAppTip: false,
      emptyText: '群组不存在',
      willTip: false,
      isSupport: true,
      isNative: false,
      appType: 'browser',
      isAuto: false,
    }
  },
  head () {
    return {
      title: '加入群组'
    }
  },
  computed: {
    ua () {
      return this.$store.state.ua
    },
    isMobile () {
      return /mobile/i.test(this.ua)
    },
    fromUid () {
      return this.$route.query.from_uid
    },
    groupId () {
      return this.$route.query.group_id
    },
    type () {
      return this.$route.query.type
    },
    ct () {
      return this.$route.query.ct || 'message_group'
    },
    appVersion () {
      return this.$store.state.native.version
    }
  },
  async fetch () {
    if (this.groupId) {
      try {
        const { data } = await postGroupQuery({
          group_id: Number(this.groupId)
        })
        // console.log(data)
        this.emptyText = data.result
        if (data.code === 0) {
          this.group = data.data
        } else {
          this.isEmpty = true
        }
      } catch (err) {
        this.isEmpty = true
      }
    } else {
      this.isEmpty = true
    }
  },
  watch: {
    showAppTip (val) {
      this.stat('yunpan_h5_download_page_show')
    },
    appVersion: {
      handler (val) {
        if (Number(val) > 0) {
          this.isNative  = this.$native.isAndroidNative || this.$native.isIOSNative
          this.autoCallApp()
        }
      },
      immediate: true
    },
  },
  methods: {
    stat (event, data = {}) {
      this.$stat('message', event, { join_group_way: this.type === 'qr' ? '2_code' : 'group_link', apptype: this.appType, ...data })
    },
    autoCallApp () {
      // 判断ios手雷版本支持 >= 11777, 以及安卓版本 >= 14080 才支持群组
      if (this.isMobile && this.isNative) {
        if ((this.$native.isIOS && this.appVersion <= 11777) || (this.$native.isAndroidNative && this.appVersion < 14080)) {
          this.isSupport = false
        } else {
          this.isAuto = true
          this.callApp()
        }
      }
    },
    async callApp (button = false) {
      if (this.willTip) {
        this.isShowTip = true
        return
      }
      if (button) {
        this.stat('yunpan_h5_download_page_click', { button })
      } else {
        this.stat('yunpan_h5_join_group_page_click')
        if (!this.isSupport && (this.isNative)) {
          this.$native.toast('无法加入,请使用新版迅雷')
          return
        }
      }
      let copyText = ''
      const params = {
        from_uid: this.fromUid,
        group_id: this.groupId,
        type: this.type
      }
      if (/android/i.test(this.ua)) {
        if (!this.$native.isAndroidNative) {
          copyText = `newuser_channel:1x00011397;message_group:${location.href}`
          this.$copyText(copyText)
        }
        this.$native.callAndroid({
          target: 'group_invite',
          action: 'link',
          params,
          timeout: 2000,
          from: '',
          callback: () => {
            if (this.isNative && this.isSupport) {
              return
            }
            if (this.isAuto) {
              this.isAuto = false
              return
            }
            this.showAppTip = true
            this.$native.evokeByTagA(
              'https://m.down.sandai.net/mobile/xunlei_message_group.apk'
            )
          }
        })
        if (this.isNative && this.isSupport) {
          await this.$native.sleep(1000)
          this.$native.sendMessage({ platform: 'android', name: 'xlFinishSelfActivity' })
        }
      } else {
        /**
       * 2024-03-15
       * 经过@刘靖玮 和客户端 @叶可凡 的讨论
       * 由于这个是在 h5 到端内场景才有用，纯端内是不是不需要识别这个所以
       * 产品建议：加个判断，旧逻辑不动，新增的纯端内场景不写剪切板
       * */
        if (!this.$native.isIOSNative) {
          /**
           * 2024-03-15
           *@叶可凡 确认copyText多了{
           * `#*TDM-{${Base64.encode(location.href)}*#` 去除{
           * `#*TDM-${Base64.encode(location.href)}*#`
           */
          copyText = `#*TDM-${Base64.encode(location.href)}*#`
          this.$copyText(copyText)
        }
        if (this.$native.isIOSNative) {
          this.$native.sendMessage({
            platform: 'ios',
            name: 'xunleiQuery',
            params: {
              target: 'message',
              action: 'applyJoinGroup',
              params: {
                ...params,
                groupId: this.groupId // ios现在只支持读取groupId,后续会统一
              }
            }
          }, { noCallback: true })
        } else {
          this.$native.callIOS({
            target: 'message',
            action: 'applyJoinGroup',
            params,
            timeout: 2000,
            isClean: false,
            from: '',
            callback: () => {
              this.isShowTip = true
            }
          })
        }
      }
    }
  },
  mounted () {
    if (this.isMobile) {
      if (this.isNative) {
        this.appType = 'native'
      } else if (/MicroMessenger/i.test(this.ua)) {
        this.appType = 'wechat'
      } else if (/QQ/.test(this.ua)) {
        this.appType = 'qq'
      } else if (/dingtalk/i.test(this.ua)) {
        this.appType = 'dingtalk'
      }
      if (/(MicroMessenger|dingtalk)/i.test(this.ua)) {
        // 微信和钉钉浏览器内
        this.willTip = true
      }
    }
    this.stat(this.isMobile ? 'yunpan_h5_join_group_page_show' : 'web_join_group_page_show')
    if (this.groupId) {
      createQrCode(location.href).then((img) => {
        this.qrLink = img
      })
    }
  }
}
</script>

<style lang="scss">
@import '~/assets/scss/reset.scss';
@import '~/assets/group-invite/index.scss';
</style>
